module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure.Precast_Pre-Tensioned_Beam_Bridge_30m.Concrete.fc39cc58.png";